import React, {Component} from 'react';
import AuctionItem from '../AuctionItem';
import {ListContainer, NotHasMore, NoData} from './style';
import {observer} from "mobx-react";
import {InfiniteLoader} from '@jdcfe/yep-react';
import noDataImg from '../../../assets/image/no_data.png';
import unit_institution from "../../../store/asset_institution/unit_institution";
import { isElementInViewport, BUSINESS_INFO } from '../../../utils/tool'

@observer
class AuctionList extends Component {
  // 倒计时执行函数对象

  constructor(props) {
    super(props);
    this.timer = null;
    this.visibilityChangeHandle = this.visibilityChangeHandle.bind(this)
  }

  componentDidMount() {
    // 统一定时器
    this.countdown()
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    this.timer = setInterval(() => {
      this.countdown();
    }, 1000);
    document.addEventListener('visibilitychange', this.visibilityChangeHandle);
  }

  componentWillUnmount() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
    document.removeEventListener('visibilitychange', this.visibilityChangeHandle);
  }

  visibilityChangeHandle() {
    if (document.visibilityState === 'visible') {
      this.updateRealtimeDataInViewPort()
    }
  }

  updateRealtimeDataInViewPort() {
    const {
      getRealTimeDataByPaimaiIds
    } = this.props.store
    const items = document.querySelectorAll('.auction-item')
    const paimaiIds = []
    if (items) {
      for (let i = 0; i < items.length; i++) {
        if (isElementInViewport(items[i])) {
          paimaiIds.push(items[i].getAttribute('data-paimaiid'))
        }
      }
    }
    if (paimaiIds.length) {
      getRealTimeDataByPaimaiIds(paimaiIds)
    }
  }

  countdown() {
    const {isLoadNext} = this.props
    if(isLoadNext===false){
      return
    }
    const {
      auctionList,
      realTimeData,
      saveCurrData,
      getRealTimeDataByPaimaiIds
    } = this.props.store
    let paimaiIds = []
    auctionList.forEach(item => {
      if (realTimeData[item.id]) {
        const {
          auctionStatus,
          remainTime,
        } = realTimeData[item.id]
        if (auctionStatus !== 2) {
          if (remainTime <= 0) {
            paimaiIds.push(item.id);
          } else {
            realTimeData[item.id].remainTime = remainTime - 1000
          }
        }
      }
    })
    saveCurrData('realTimeData', realTimeData)
    
    if (paimaiIds && paimaiIds.length) {
      getRealTimeDataByPaimaiIds(paimaiIds)
    }
  }

  onScroll = (e) => {

  };

  loadMore = () => {
    const {isLoadNext} = this.props
    if(isLoadNext===false){
      return
    }
    const {getAuctionList} = this.props.store;
    if(unit_institution.publishSource==BUSINESS_INFO.ZICHAN.code || unit_institution.publishSource==BUSINESS_INFO.POCHAN.code || unit_institution.publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
      if (unit_institution.curTabIndex === 1) {
        getAuctionList();
      }
    }else{
      getAuctionList();
    }
  };

  isShowAuctionList=()=>{
    let bool = false
    const {curTabIndex, publishSource} = unit_institution
    if(publishSource==BUSINESS_INFO.ZICHAN.code || publishSource==BUSINESS_INFO.POCHAN.code || unit_institution.publishSource==BUSINESS_INFO.HAIGUANANDZF.code){
      if(curTabIndex===1){
        bool = true
      }
    }else {
      if(curTabIndex===0){
        bool = true
      }
    }
    return bool
  }

  render() {
    const {auctionList, targetListHasMore, realTimeData, errorMessage} = this.props.store;
    return (
      <div>
        {this.isShowAuctionList() &&
        <ListContainer style={{ paddingBottom: '0.6rem' }}>
          {auctionList && auctionList.length !== 0 && (<InfiniteLoader
            dataLength={auctionList.length}
            hasMore={targetListHasMore}
            onScroll={(e) => {
              this.onScroll(e);
            }}
            loadMore={() => {
              this.loadMore();
            }}
          >
            {auctionList.length !== 0 && auctionList.map(
              (value,index) => (<AuctionItem
                index={index}
                key={value.id}
                itemInfo={value}
                realTimeData={realTimeData[value.id]}
              ></AuctionItem>))
            }
            {
              auctionList.length !== 0 && (!targetListHasMore || !!errorMessage.length) &&
              (
                <NotHasMore>
                  没有更多啦~
                </NotHasMore>
              )
            }
          </InfiniteLoader>)}
          {
            !!errorMessage.length && !auctionList.length ? (
              <NoData>
                <img src={noDataImg} alt=""/>
                <p>{errorMessage}</p>
              </NoData>
            ) : 
            auctionList.length === 0 && !targetListHasMore ?
            (
              <NoData>
                <img src={noDataImg} alt=""/>
                <p>暂无符合条件的标的，去看看其他标的吧~</p>
              </NoData>
            ) : null
          }
          {
            auctionList.length === 0 && targetListHasMore &&
            (
              <NoData>
              </NoData>
            )
          }
        </ListContainer>
        }
      </div>
    )
  }
}

export default AuctionList;
